import React from "react"
import KEYBlue from "../common/keylist-blue"

const SymfonywebServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <h2 className="fw-700 fs-xl">
                Symfony Development Services We Provide:
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Symfony Application Development" />
              <KEYBlue text="Symfony REST API Development" />
              <KEYBlue text="Customization and Integration" />
              <KEYBlue text="Symfony Template/Theme Design" />

            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Symfony CMS Development" />
              <KEYBlue text="Symfony Plugin Development" />
              <KEYBlue text="Symfony Ecommerce Development" />
              <KEYBlue text="Symfony Support & Maintenance" />

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SymfonywebServices
